module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "cont",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "h2f"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_ix",
      "title": "ix"
    }
  }, [_c('b', [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf0",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780253041401_Acknowledgments"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "abb"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780253041401_Abbreviations"
    }
  }, [_c('i', [_vm._v("Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "pre"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780253041401_Preface"
    }
  }, [_c('i', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf1",
    attrs: {
      "id": "int"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780253041401_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp",
    attrs: {
      "id": "pt1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253041401_Part_1"
    }
  }, [_vm._v("Part I"), _c('span', {
    staticClass: "spacep"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Christianity Comes to Oneida Country")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp1",
    attrs: {
      "id": "pt1a"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780253041401_Part_1#rpt1a"
    }
  }, [_vm._v("Editors’ Introduction to Part I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/9780253041401_Chapter_1"
    }
  }, [_vm._v("1"), _c('span', {
    staticClass: "spacec1"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("The Oneida World before Christianity / Laurence M. Hauptman")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041401_Chapter_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2"), _c('span', {
    staticClass: "spacec1"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Oneidas and Missionaries, 1667–1816 / Karim M. Tiro")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041401_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3"), _c('span', {
    staticClass: "spacec1"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Flawed Shepherd: Eleazer Williams, John Henry Hobart, and the Episcopal Mission to the Oneidas / Michael Leroy Oberg")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp",
    attrs: {
      "id": "pt2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253041401_Part_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II"), _c('span', {
    staticClass: "spacep1"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("The Oneida Episcopal Mission: The First Century in Wisconsin")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp1",
    attrs: {
      "id": "pt2a"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041401_Part_2#rpt2a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Editors’ Introduction to Part II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041401_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4"), _c('span', {
    staticClass: "spacec1"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Another Leatherstocking Tale: Susan Fenimore Cooper, the Episcopal Church, and the Oneidas / Laurence M. Hauptman, L. Gordon McLester III, and Judy Cornelius-Hawk")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_x",
      "title": "x"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253041401_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5"), _c('span', {
    staticClass: "spacec1"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("A Mission of Mutuality: The Relationship between the Oneidas and the Nashotah House Theological Seminary / Very Rev. Steven A. Peay")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041401_Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6"), _c('span', {
    staticClass: "spacec1"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Wearing Two Hats: Cornelius Hill and John Archiquette, Oneida Nation and Episcopal Church Leaders / L. Gordon McLester III and Laurence M. Hauptman")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041401_Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7"), _c('span', {
    staticClass: "spacec1"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("The Episcopal Mission 1853–1909: Three Church Accounts")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec1"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041401_Chapter_7#rsec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ellen Saxton Goodnough, “Christmastime at the Mission, 1869”")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec2"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041401_Chapter_7#rsec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rev. Solomon S. Burleson Describes Providing Medical Care at Oneida")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec3"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041401_Chapter_7#rsec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rev. Frank Wesley Merrill on Missionary Sybil Carter and the Oneida Women Lace Makers, 1899")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp",
    attrs: {
      "id": "pt3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253041401_Part_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part III"), _c('span', {
    staticClass: "spacep2"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Oneida First-Person Accounts of the Episcopal Church and Its Clergy")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocp1",
    attrs: {
      "id": "pt3a"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041401_Part_3#rpt3a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Editors’ Introduction to Part III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch8"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041401_Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8"), _c('span', {
    staticClass: "spacec1"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Six Oneidas Recount Eight WPA Oral Histories, 1938–1942, about the Episcopal Mission")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec4"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041401_Chapter_8#rsec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sarah Cornelius")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec5"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041401_Chapter_8#rsec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Guy Elm")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec6"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041401_Chapter_8#rsec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lena Silas")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec7"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041401_Chapter_8#rsec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oscar Archiquette")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec8"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041401_Chapter_8#rsec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pearl House")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec9"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041401_Chapter_8#rsec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("David Skenandore")])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch9"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041401_Chapter_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9"), _c('span', {
    staticClass: "spacec1"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Ten Contemporary Oneidas Reminisce in Nine Accounts about the Holy Apostles Episcopal Church and the Episcopal Mission")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec10"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041401_Chapter_9#rsec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Father Christian Puts Me on the Right Path / Kenneth Hoyan House")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec11"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xi",
      "title": "xi"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253041401_Chapter_9#rsec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reminiscences about the Oneida Mission School / Blanche Powless")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec12"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041401_Chapter_9#rsec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reflections on My Father, Deacon Edmund Powless / Kathy Powless Hughes")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec13"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041401_Chapter_9#rsec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reminiscences of Two Oneida Nuns / Sister Theresa Rose and Mother Superior Alicia Torres of the Order of the Teachers of the Children of God")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec14"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041401_Chapter_9#rsec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recollections about the Oneida Episcopal Mission / Pearl Schuyler McLester")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec15"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041401_Chapter_9#rsec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Father R. Dewey Silas / Deacon Deborah Heckel")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec16"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041401_Chapter_9#rsec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("As I Remember the Women of the Oneida Mission / Judy Cornelius-Hawk")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec17"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041401_Chapter_9#rsec17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oneida Lace-Making, Then and Now / Betty McLester and Judy Skenandore")])]), _vm._v(" "), _c('p', {
    staticClass: "tocs",
    attrs: {
      "id": "sec18"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041401_Chapter_9#rsec18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Oneida Hymn Singers / L. Gordon McLester III")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp",
    attrs: {
      "id": "pt4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253041401_Part_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part IV"), _c('span', {
    staticClass: "spacep3"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Reflections on Wisconsin Oneida Episcopal Church Relations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch10"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041401_Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10"), _c('span', {
    staticClass: "spacec2"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Putting Oneida Episcopal History in Perspective: American Indian Encounters with Christianity / Christopher Vecsey")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch11"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041401_Chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11"), _c('span', {
    staticClass: "spacec2"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("The Wisconsin Oneidas and the Episcopal Church: Then and Now / L. Gordon McLester III, Laurence M. Hauptman, Judy Cornelius-Hawk, and Kenneth Hoyan House")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf1",
    attrs: {
      "id": "con"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041401_Contributors",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Contributors")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "appa"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041401_Appendix_A",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Appendix A: Timeline")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "appb"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041401_Appendix_B",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Appendix B: Episcopal Priests, Vicars, and Deacons Who Have Served the Oneidas in Wisconsin")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "appc"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xii",
      "title": "xii"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253041401_Appendix_C",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Appendix C: Bishops Who Have Headed the Diocese")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "bib"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041401_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "ind"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253041401_Index",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64bd4612","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253041401_Contents.vue
// module id = 75
// module chunks = 0